// Validação/normalização de CNPJ no formato ALFANUMÉRICO (Serpro/Receita):
// os 12 primeiros caracteres podem ser [0-9A-Z] e os 2 últimos são dígitos
// verificadores numéricos (módulo 11, valor = charCodeAt - 48). Mantém
// retrocompatibilidade com CNPJ numérico. Espelha app/Support/Cnpj.php do backend.

const WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

export function normalize(value) {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  return String(value).toUpperCase().replace(/[^0-9A-Z]/g, '')
}

function checkDigit(c, length) {
  const offset = WEIGHTS.length - length
  let sum = 0

  for (let i = 0; i < length; i++) {
    sum += (c.charCodeAt(i) - 48) * WEIGHTS[offset + i]
  }

  const mod = sum % 11

  return mod < 2 ? 0 : 11 - mod
}

export function isValid(value) {
  const c = normalize(value)

  if (c.length !== 14) {
    return false
  }

  // 12 primeiros alfanuméricos, 2 últimos (dígitos verificadores) numéricos.
  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(c)) {
    return false
  }

  // Rejeita sequências com todos os caracteres iguais.
  if (/^(.)\1{13}$/.test(c)) {
    return false
  }

  if (parseInt(c[12], 10) !== checkDigit(c, 12)) {
    return false
  }

  if (parseInt(c[13], 10) !== checkDigit(c, 13)) {
    return false
  }

  return true
}
